import {Stack, Typography, Divider} from "@mui/material";
import AdmsIdentifierDisplay from "./AdmsIdentifierDisplay";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function PublisherDisplay(props) {
  // const [mappings, setMappings] = useState(props.mappings);
  const {mappings, defaultLanguage, iprHolder} = props;
  // console.log(iprHolder);

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }
  if (!iprHolder || iprHolder.length === 0) return null;

  return (
    <Stack sx={{pt: 1, pb: 2}} spacing={1}>
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{getLabel(keys.iprHolder, "IprHolder")}</Typography>
      {iprHolder.map((item, index) => {
        const isLastElement = index === iprHolder.length - 1;
        // console.log(item);
        return (
          <div key={index}>
            {item.name && !isEmpty(item.name.getValue(defaultLanguage)) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.name, "name")}
                </Typography>
                <Typography variant="body1">{item.name.getValue(defaultLanguage)}</Typography>
              </div>
            )}
            <Stack sx={{pt: 1}} spacing={1}>
              <AdmsIdentifierDisplay defaultLanguage={defaultLanguage} mappings={mappings} admsIdentifierList={item.admsList} />
            </Stack>
            <Divider component="div" role="presentation" className={`dashed ${isLastElement ? "hide-divider" : ""}`} />
          </div>
        );
      })}
    </Stack>


  );
}
